import {
  GET_USER_PERFORMANCE_DATA,
  GET_USER_PERFORMANCE_DATA_FAIL,
  GET_USER_PERFORMANCE_DATA_START,
  GET_USER_PERFORMANCE_DATA_SUCCESS,
  USER_PERFORMANCE_SEARCH_USERS_SUCCESS,
  USER_PERFORMANCE_SEARCH_USERS_START,
  USER_PERFORMANCE_SEARCH_USERS_FAIL,
  USER_PERFORMANCE_ACTIVE_USERS_FILTERS,
  USER_PERFORMANCE_RESET_USERS_FILTERS,
  USER_PERFORMANCE_SEARCH_SITES_SUCCESS,
  USER_PERFORMANCE_SEARCH_SITES_START,
  USER_PERFORMANCE_SEARCH_SITES_FAIL,
  USER_PERFORMANCE_ACTIVE_SITES_FILTERS,
  USER_PERFORMANCE_RESET_SITES_FILTERS,
  USER_PERFORMANCE_HYDRATE_ACTIVE_USERS,
  USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_START,
  USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_SUCCESS,
  USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_FAIL,
  USER_PERFORMANCE_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
  USER_PERFORMANCE_RESET_USER_DATA,
} from 'actions/userPerformance';

import { getListPageSuccessNewData } from '../utils';

export const defaultState = {
  error: false,
  loading: null,
  users: {},
  usersFilter: {
    data: [],
    total: 0,
    loading: false,
    activeItems: [],
  },
  sites: {
    data: [],
    total: 0,
    loading: false,
    activeItems: [],
  },
};

export default function userPerformance(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_PERFORMANCE_DATA:
    case GET_USER_PERFORMANCE_DATA_START:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case GET_USER_PERFORMANCE_DATA_SUCCESS:
      return {
        ...state,
        error: false,
        loading: !!payload.status,
        users: payload.status
          ? { ...state.users }
          : {
              ...payload,
              data: getListPageSuccessNewData(
                state.users,
                payload.data,
                payload.links,
              ),
            },
      };
    case GET_USER_PERFORMANCE_DATA_FAIL:
      return {
        ...state,
        error: payload.json,
        loading: false,
        users: [],
      };
    case USER_PERFORMANCE_SEARCH_USERS_SUCCESS: {
      const { data, total } = payload;
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          data,
          total,
          loading: false,
        },
      };
    }
    case USER_PERFORMANCE_SEARCH_USERS_START: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: true,
        },
      };
    }
    case USER_PERFORMANCE_SEARCH_USERS_FAIL: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: false,
        },
      };
    }
    case USER_PERFORMANCE_ACTIVE_USERS_FILTERS: {
      const activeItems = [
        ...state.usersFilter.activeItems,
        ...payload.filter(
          item => !state.usersFilter.activeItems.find(a => a.id === item.id),
        ),
      ];
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          activeItems,
        },
      };
    }
    case USER_PERFORMANCE_RESET_USERS_FILTERS: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          data: [],
          total: 0,
          activeItems: payload,
        },
      };
    }
    case USER_PERFORMANCE_SEARCH_SITES_SUCCESS: {
      const { data, total } = payload;
      return {
        ...state,
        sites: {
          ...state.sites,
          data,
          total,
          loading: false,
        },
      };
    }
    case USER_PERFORMANCE_SEARCH_SITES_START: {
      return {
        ...state,
        sites: {
          ...state.sites,
          loading: true,
        },
      };
    }
    case USER_PERFORMANCE_SEARCH_SITES_FAIL: {
      return {
        ...state,
        sites: {
          ...state.sites,
          loading: false,
        },
      };
    }
    case USER_PERFORMANCE_ACTIVE_SITES_FILTERS: {
      const activeItems = [
        ...state.sites.activeItems,
        ...payload.filter(
          item => !state.sites.activeItems.find(a => a.id === item.id),
        ),
      ];
      return {
        ...state,
        sites: {
          ...state.sites,
          activeItems,
        },
      };
    }
    case USER_PERFORMANCE_RESET_SITES_FILTERS: {
      return {
        ...state,
        sites: {
          ...state.sites,
          data: [],
          total: 0,
          activeItems: payload,
        },
      };
    }

    case USER_PERFORMANCE_HYDRATE_ACTIVE_DYNAMIC_FILTERS: {
      const [storeKey] = Object.keys(action.payload);
      const value = action.payload[storeKey];
      const count = value.length;

      return {
        ...state,
        [storeKey]: {
          data: [...value],
          count,
          total: count,
          loading: false,
        },
      };
    }

    case USER_PERFORMANCE_HYDRATE_ACTIVE_USERS: {
      return state;
    }
    case USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          data,
          loading: false,
        },
      };
    }
    case USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_START: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: true,
        },
      };
    }
    case USER_PERFORMANCE_HYDRATE_ACTIVE_USERS_FAIL: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: false,
        },
      };
    }
    case USER_PERFORMANCE_RESET_USER_DATA: {
      return {
        ...state,
        users: {},
      };
    }
    default:
      return state;
  }
}
